export const RESET_CONTACTS = 'RESET_CONTACTS'
export const SET_CONTACTS = 'SET_CONTACTS'
